import { PRETTY, HOURS, DAYS } from '@atlassian/jira-common-constants/src/jira-settings.tsx';
import type { TimeFormat } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';

export const timeFormatMap: Map<string, TimeFormat> = new Map([
	['HOURS', HOURS],
	['hours', HOURS],
	['DAYS', DAYS],
	['days', DAYS],
	['PRETTY', PRETTY],
	['pretty', PRETTY],
]);
